import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import Settings from '../data/settings';
import { AuthSlice, createAuthSlice } from './authSlice';
import { UserSlice, createUserSlice } from './userSlice';
import { StoreSlice, createStoreSlice } from './storesSlice';
import { IndexSlice, createIndexSlice } from './indexSlice';

export * from './indexSlice';
export * from './authSlice';
export * from './userSlice';
export * from './storesSlice';

export const languages: string[] = [];
languages[1] = 'en';
languages[2] = 'it';

export type CombinedSlices = IndexSlice & AuthSlice & StoreSlice & UserSlice;

export const useUderlyStore = create<CombinedSlices, [["zustand/persist", CombinedSlices]]>(
  persist(
    (...a) => ({
      ...createAuthSlice(...a),
      ...createUserSlice(...a),
      ...createStoreSlice(...a),
      ...createIndexSlice(...a)
    }),
    { name: `${Settings.provider?.id!}-${Settings.project.id!}` }
  )
);
